let token: string | null = null;
let loginToken: string | null = null;

/**
 * Capture the `lt` (login token) query param before anything else runs, then remove it from the
 * URL so the token isn't left in the address bar or in history. The Lasso Portal does the
 * equivalent server-side before serving its index page.
 *
 * This has to happen at module load: `AuthProvider` fires the `/login` query as soon as it mounts,
 * and TanStack Router's root `validateSearch` strips search params it doesn't know about.
 */
const captureLoginToken = () => {
  const params = new URLSearchParams(window.location.search);
  const lt = params.get("lt");
  if (!lt) return;

  loginToken = lt;

  params.delete("lt");
  const search = params.toString();
  window.history.replaceState(
    null,
    "",
    window.location.pathname +
      (search ? `?${search}` : "") +
      window.location.hash,
  );
};

captureLoginToken();

export const storage = {
  getToken: (): string | null => token,
  setToken: (newToken: string): void => {
    token = newToken;
  },
  clearToken: () => {
    token = null;
  },
  getLoginToken: (): string | null => loginToken,
  clearLoginToken: () => {
    loginToken = null;
  },
};
